export default "__VITE_ASSET__DWp2zYiP__"